import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {MetricTileComponent} from '../../../metric-tile/metric-tile.component';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {RfpTotalResult} from '../../rfp-individual-results.types';

@Component({
  selector: 'app-rfp-total-summary',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, TranslocoPipe, MetricTileComponent, ScoreBarComponent],
  templateUrl: './rfp-total-summary.component.html',
})
export class RfpTotalSummaryComponent {
  readonly total = input.required<RfpTotalResult>();

  protected readonly rankParams = computed(() => ({
    rank: this.total().rank,
    count: this.total().providerCount,
  }));
}
